import { render, staticRenderFns } from "./commenTop.vue?vue&type=template&id=ddfce030&scoped=true"
import script from "./commenTop.vue?vue&type=script&lang=js"
export * from "./commenTop.vue?vue&type=script&lang=js"
import style0 from "./commenTop.vue?vue&type=style&index=0&id=ddfce030&prod&lang=scss&scoped=true"
import style1 from "./commenTop.vue?vue&type=style&index=1&id=ddfce030&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddfce030",
  null
  
)

export default component.exports